import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from '../../global/services/http-gateway.service';
import { Observable } from 'rxjs';
import {
  BaseClusterContract,
  ClusterContract,
  CreateClusterContract,
  UpdateClusterContract,
} from '../store/clusters/types';

@Injectable({ providedIn: 'root' })
export class ClustersApi {
  private httpService = inject(HttpGatewayService);

  public getCluster(
    salesOrganizationId: string,
    clusterId: string,
  ): Observable<ClusterContract> {
    return this.httpService.get<ClusterContract>(
      `/clusters/${salesOrganizationId}/${clusterId}`,
    );
  }

  public getClusters(
    salesOrganizationId: string,
  ): Observable<ClusterContract[]> {
    return this.httpService.get<ClusterContract[]>(
      `/clusters/${salesOrganizationId}`,
    );
  }

  public getClustersForSelection(
    salesOrganizationId: string,
  ): Observable<BaseClusterContract[]> {
    return this.httpService.get<BaseClusterContract[]>(
      `/clusters/${salesOrganizationId}/selectables`,
    );
  }

  public createCluster(
    salesOrganizationId: string,
    createClusterContract: CreateClusterContract,
  ): Observable<ClusterContract> {
    return this.httpService.post<ClusterContract>(
      `/clusters/${salesOrganizationId}`,
      createClusterContract,
    );
  }

  public updateCluster(
    cluster: UpdateClusterContract,
  ): Observable<ClusterContract> {
    return this.httpService.put<ClusterContract>('/clusters', cluster);
  }

  public removeClusterAdmin(
    orgId: string,
    clusterId: string,
    userId: string,
  ): Observable<void> {
    return this.httpService.delete<void>(
      `/clusters/${orgId}/${clusterId}/admins/${userId}`,
    );
  }
}
